import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';

@Component({
    selector: 'knbr-cwt-invoice-header',
    templateUrl: './cwt-invoice-header.component.html',
    styleUrl: './cwt-invoice-header.component.scss'
})
export class CwtInvoiceHeaderComponent {

}
